import { z } from 'zod';
import { ArtistIdSchema } from './common.js';
import { MAX_PEERS } from './peers.js';
export const PeerSetSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    ownerUpn: z.string(),
    shared: z.boolean(),
    members: z.array(z.object({ artistId: ArtistIdSchema, artistName: z.string() })),
    updatedAt: z.iso.datetime(),
});
export const PeerSetInputSchema = z.object({
    name: z.string().min(1).max(80),
    shared: z.boolean().default(false),
    members: z.array(ArtistIdSchema).min(1).max(MAX_PEERS),
});
//# sourceMappingURL=peer-sets.js.map